import { Connection, TransactionConfirmationStatus } from '@solana/web3.js'

// TODO: eslint が通るよう変更
export async function waitForTransactionConfirmation(
  cntx: Connection,
  signature: string,
  commitment: TransactionConfirmationStatus = 'confirmed',
  timeoutMs = 90000
) {
  const start = Date.now()
  let shouldContinue = true

  while (shouldContinue) {
    // eslint-disable-next-line no-await-in-loop
    const { value } = await cntx.getSignatureStatuses([signature])

    const status = value[0]
    if (status) {
      if (status.err) {
        throw new Error(`Transaction failed: ${JSON.stringify(status.err)}`)
      }
      if (status.confirmationStatus === commitment || status.confirmationStatus === 'finalized') {
        shouldContinue = false
        return status
      }
    }

    if (Date.now() - start > timeoutMs) {
      throw new Error(`Timeout while waiting for confirmation of ${signature}`)
    }

    // 過度な負荷防止: 1秒待機
    // eslint-disable-next-line no-await-in-loop
    await new Promise((resolve) => setTimeout(resolve, 1000))
  }

  // ESLint対策用
  throw new Error(`Unexpected state while waiting for confirmation of ${signature}`)
}
